export default "__VITE_ASSET__BjWQip4K__"